export function updateTicketProgress(progress) {
    document.querySelectorAll('[data-ticket-progress]').forEach((root) => {
        root.classList.remove('ticket-state-empty', 'ticket-state-partial', 'ticket-state-complete');
        root.classList.add(`ticket-state-${progress.state}`);
        const count = root.querySelector('[data-ticket-count]');
        const label = root.querySelector('[data-ticket-label]');
        const hint = root.querySelector('[data-ticket-hint]');
        const icon = root.querySelector('[data-ticket-icon]');
        if (count) count.textContent = String(progress.saved);
        if (label) label.textContent = progress.label;
        if (icon) icon.className = `fa-duotone fa-solid ${progress.complete ? 'fa-circle-check' : progress.saved > 0 ? 'fa-circle-exclamation' : 'fa-ticket'}`;
        if (hint) hint.textContent = progress.missingClosed > 0 ? 'Některé chybějící tipy teď nelze doplnit.'
            : progress.complete ? (progress.editable > 0 ? 'Hotovo. Tipy můžeš do jejich uzávěrky upravit.' : 'Hotovo. Tipy už nelze upravovat.')
            : progress.editable > 0 ? 'Vyplň celý hlavní tiket a získej právo hodnotit hráče.' : 'Tipy už nelze doplnit.';
        const track = root.querySelector('[data-ticket-segments]');
        track?.setAttribute('aria-label', `Uloženo ${progress.saved} z ${progress.total} tipů`);
        for (const segment of progress.segments) {
            const el = root.querySelector(`[data-ticket-segment="${segment.id}"]`);
            if (!el) continue;
            el.classList.toggle('is-saved', segment.saved);
            el.setAttribute('aria-label', `${segment.label}: ${segment.saved ? 'uloženo' : segment.editable ? 'zbývá vyplnit' : 'bez tipu, uzavřeno'}`);
        }
    });
}

export function initMarketForms(root) {
    root.querySelectorAll('[data-v2-market-form]').forEach((form) => {
        if (form.dataset.v2Ready === '1') return;
        form.dataset.v2Ready = '1';
        const hidden = form.querySelector('[data-v2-answer-json]');
        if (!hidden) return;

        const sync = () => {
            const type = form.dataset.answerType;
            let answer = {};
            if (type === 'score') answer = { home: form.querySelector('[data-v2-score-home]')?.value ?? '', away: form.querySelector('[data-v2-score-away]')?.value ?? '' };
            else if (type === 'player') answer = { player_id: form.querySelector('[data-v2-player]')?.value ?? '' };
            else if (type === 'number') answer = { value: form.querySelector('[data-v2-number]')?.value ?? '' };
            else if (type === 'boolean') answer = { value: form.querySelector('[data-v2-boolean]')?.value ?? '' };
            hidden.value = JSON.stringify(answer);
        };

        let savedAnswer = hidden.value;
        const card = form.closest('[data-ticket-market]');
        const markDirty = () => {
            sync();
            const dirty = savedAnswer !== hidden.value;
            card?.classList.toggle('is-dirty', dirty);
            const stateCopy = card ? document.querySelector(`[data-market-state-copy="${card.dataset.ticketMarket}"]`) : null;
            if (stateCopy) stateCopy.textContent = dirty ? 'Neuložené změny.'
                : `${card.classList.contains('is-saved') ? 'Tip uložen.' : 'Tip není vyplněný.'}${card.dataset.closedReason ? ' ' + card.dataset.closedReason + '.' : ''}`;
            const badge = card?.querySelector('[data-v2-market-saved]');
            if (badge) {
                badge.classList.toggle('hidden', !dirty && !card.classList.contains('is-saved'));
                badge.textContent = dirty ? 'Neuložené změny' : '✓ Tip uložen';
            }
        };
        form.addEventListener('input', markDirty);
        form.addEventListener('change', markDirty);
        form.addEventListener('submit', async (event) => {
            sync();
            if (!form.dataset.ajaxUrl && !form.action) return;
            event.preventDefault();
            const submit = form.querySelector('[type="submit"]');
            const status = form.querySelector('[data-v2-save-status]');
            if (form.dataset.saving === '1') return;
            form.dataset.saving = '1';
            form.setAttribute('aria-busy', 'true');
            const originalSubmit = submit ? {
                html: submit.innerHTML, value: submit.value,
                width: submit.style.width, minWidth: submit.style.minWidth,
                label: submit.getAttribute('aria-label'),
            } : null;
            if (submit) {
                // Reserve the existing button box before swapping its content.
                const width = `${submit.getBoundingClientRect().width}px`;
                submit.style.width = width;
                submit.style.minWidth = width;
                submit.disabled = true;
                submit.setAttribute('aria-label', 'Ukládám tip');
                if (submit.tagName === 'INPUT') submit.value = '…';
                else submit.innerHTML = '<i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>';
            }
            if (status) { status.textContent = 'Ukládám…'; status.classList.remove('text-red-600','text-emerald-600'); status.classList.add('text-slate-400'); }
            const sentAnswer = hidden.value;
            try {
                const response = await fetch(form.dataset.ajaxUrl || form.action || window.location.href, {
                    method: 'POST',
                    body: new FormData(form),
                    credentials: 'same-origin',
                    headers: {'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json'},
                });
                const data = await response.json();
                if (!response.ok || !data.ok) throw new Error(data.message || 'Tip se nepodařilo uložit.');
                if (status) { status.textContent = data.message || 'Tip uložen'; status.classList.remove('text-slate-400','text-red-600'); status.classList.add('text-emerald-600'); }
                const revision = form.querySelector('[data-v2-revision-status]');
                if (revision) revision.textContent = `Změny zbývají: ${data.revisionsRemaining}`;
                document.querySelectorAll(`[data-market-revisions="${data.marketId}"]`).forEach(el => {el.textContent = String(data.revisionsRemaining);});
                document.querySelectorAll(`[data-v2-entry-label="${data.marketId}"]`).forEach((el) => { el.textContent = data.entryLabel || 'Tip uložen'; });
                savedAnswer = sentAnswer;
                card?.classList.add('is-saved');
                card?.classList.remove('is-dirty');
                document.querySelectorAll(`[data-v2-market-saved="${data.marketId}"]`).forEach((el) => {
                    el.textContent = '✓ Tip uložen';
                    el.classList.remove('hidden');
                });
                if (data.ticketProgress) updateTicketProgress(data.ticketProgress);
                if (data.marketCanPredict === false) {
                    if (card) card.dataset.closedReason = data.marketClosedReason || 'Tip už nelze měnit';
                    form.querySelectorAll('input:not([type="hidden"]), select, button').forEach((input) => {
                        if (input.tomselect) input.tomselect.disable();
                        input.disabled = true;
                    });
                    if (submit) submit.dataset.final = '1';
                    if (revision) revision.textContent = data.marketClosedReason || 'Tip už nelze měnit';
                }
                document.querySelectorAll('[data-v2-completion-percent]').forEach((el) => el.textContent = `${data.completionPercent} %`);
                document.querySelectorAll('[data-v2-completion-label]').forEach((el) => el.textContent = `${data.mainCompleted} / ${data.mainTotal} hlavních tipů`);
                document.querySelectorAll('[data-v2-completion-bar]').forEach((el) => { el.style.width = `${data.completionPercent}%`; });
                document.querySelectorAll('[data-v2-force-lock-panel]').forEach((el) => el.classList.toggle('hidden', !data.canForceLock));
                document.querySelectorAll('[data-v2-ticket-final-panel]').forEach((el) => el.classList.toggle('hidden', !data.ticketFinalized));
                if (data.ratingQualified) {
                    document.querySelectorAll('[data-v2-rating-qualified]').forEach((el) => el.classList.remove('hidden'));
                }
                markDirty();
                if (data.statsRevealed && data.ticketFinalized && !card?.classList.contains('is-dirty')) {
                    window.setTimeout(() => window.location.reload(), 350);
                }
            } catch (error) {
                console.error('Prediction V2 AJAX save failed', error);
                if (status) { status.textContent = error?.message || 'Tip se nepodařilo uložit.'; status.classList.remove('text-slate-400','text-emerald-600'); status.classList.add('text-red-600'); }
            } finally {
                form.dataset.saving = '0';
                form.removeAttribute('aria-busy');
                if (submit && originalSubmit) {
                    if (submit.tagName === 'INPUT') submit.value = originalSubmit.value;
                    else submit.innerHTML = originalSubmit.html;
                    submit.style.width = originalSubmit.width;
                    submit.style.minWidth = originalSubmit.minWidth;
                    if (originalSubmit.label === null) submit.removeAttribute('aria-label');
                    else submit.setAttribute('aria-label', originalSubmit.label);
                    if (submit.dataset.final !== '1') submit.disabled = false;
                }
            }
        });
        sync();
        savedAnswer = hidden.value;
    });
}

